import {createContext, use} from 'react'
import type {LayoutContextValue} from './types'

export const LayoutContext = createContext<LayoutContextValue | null>(null)

export function useOptionalLayoutContext(): LayoutContextValue | null {
  return use(LayoutContext)
}

export function useLayoutContext(): LayoutContextValue {
  const context = useOptionalLayoutContext()
  if (!context) {
    throw new Error('useLayoutContext must be used within a Layout component')
  }
  return context
}
